/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';
import {Panel ,  Button , Modal , Row , Col , Alert} from 'react-bootstrap';
import ContentNavigation from './content-header.js';
import Checkout from '../content-checkout.js';


export default class ContentStandardLayout extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {
            open:true
        }
    }

    isOpen(isOpen){
        this.setState({open:isOpen})
    }

    render(){

        return <div>
                    <Row>
                        <Col md={9}>
                            <ContentNavigation onOpen={this.isOpen.bind(this)} catalogUID={this.props.catalogUID} />
                            <Panel className="p-0" collapsible expanded={this.state.open}>
                                {this.props.children}
                            </Panel>
                        </Col>
                        <Col md={3}><Checkout catalogUID={this.props.catalogUID}  learning='en'  support='en'/></Col>
                    </Row>
               </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/layouts/content-standard-page.js